
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Block } from 'vcc-ui';

const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Text = makeShortcode("Text");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "vcc-ui-100-is-here"
    }}>{`VCC UI 1.0.0 Is Here`}</h1>
    <p>{`After some extensive testing and several release candidates, we're happy to `}<em parentName="p">{`finally`}</em>{` announce the arrival of our first major release! VCC UI 1.0.0`}</p>
    <p>{`VCC UI began last year as a collaboration between two product teams in our Gothenburg office. The initial goal of the project was to:`}</p>
    <ul>
      <li parentName="ul">{`Lower the unnecessary cost of design differences and implementations across product teams`}</li>
      <li parentName="ul">{`Provide a consistent Brand & UX journey for customers and end-users`}</li>
      <li parentName="ul">{`Increase developer happiness and productivity`}</li>
    </ul>
    <p>{`The project quickly outgrew it's initial scope and ambition: Today it's used internally by multiple product teams in many different geographical locations. It's also used by external partners including advertising agencies and consultancy companies.`}</p>
    <p>{`VCC UI is driven as an "Internal Open Source" project on `}<a parentName="p" {...{
        "href": "https://github.com/volvo-cars/vcc-ui"
      }}>{`GitHub`}</a>{`. So far we've had 300+ commits from ~20 collaborators across the company.`}</p>
    <p>{`Although the project has enjoyed some success, there have been some limitations and challenges that we now want to address:`}</p>
    <ul>
      <li parentName="ul">{`Limited project bandwidth (only one developer working full time)`}</li>
      <li parentName="ul">{`VCC UI is for React, what about other platforms/frameworks?`}</li>
      <li parentName="ul">{`No source of design truth`}</li>
    </ul>
    <Block extend={{
      background: '#eee',
      padding: '8px 16px'
    }} mdxType="Block">
  <Text extend={{
        color: '#555'
      }} mdxType="Text">
    Are you a developer looking to upgrade? Read the{' '}
    <Text subStyle="inline-link" href="/blog/2019-04-18-vcc-ui-1x-migration" mdxType="Text">
      1.x Migration Guide
    </Text>
  </Text>
    </Block>
    <h2 {...{
      "id": "eating-our-own-dog-food"
    }}>{`Eating our own dog food`}</h2>
    <p>{`As part of releasing 1.0 we've also taken the opportunity to rebuild the VCC UI website. Using `}<a parentName="p" {...{
        "href": "https://nextjs.org/"
      }}>{`Next.js`}</a>{` and VCC UI we've been able to quickly put together a page that delivers high quality and good performance out of the box. We're now getting a full score on all `}<a parentName="p" {...{
        "href": "https://developers.google.com/web/tools/lighthouse/"
      }}>{`Lighthouse`}</a>{` metrics: performance, accessibility, best practices and SEO.`}</p>
    <p><img parentName="p" {...{
        "src": "/blog/lighthouse-scores.jpg",
        "alt": "Lighthouse scores"
      }}></img></p>
    <p>{`If you're interested take a look at the `}<a parentName="p" {...{
        "href": "https://github.com/volvo-cars/vcc-ui-website"
      }}>{`source code`}</a>{` for this page.`}</p>
    <h2 {...{
      "id": "whats-next"
    }}>{`What's next?`}</h2>
    <p>{`Now that we have 1.0 out of the way, what's laying ahead?`}</p>
    <h3 {...{
      "id": "design-language-system"
    }}>{`Design Language System`}</h3>
    <p>{`Volvo Cars as a company has decided to take a more holistic approach to solving the issue that VCC UI originally set out to do.`}</p>
    <p>{`We are taking a step back, and creating a solution that will benefit a wider audience: A Design Language System.`}</p>
    <p>{`To do this, a Design System product team consisting of Designers, UX, Product and UI engineers has been formed, working full-time to deliver a sustainable system that will provide long term value for the company.`}</p>
    <p>{`The system will be a set of guidelines and properties describing how to design and build products that align to the Volvo Cars brand, regardless of what tool/framework/platform you are building for.`}</p>
    <p><img parentName="p" {...{
        "src": "/blog/design-system-landscape.jpg",
        "alt": "Design System"
      }}></img></p>
    <h3 {...{
      "id": "open-source"
    }}>{`Open Source`}</h3>
    <p>{`VCC UI is still a closed source project. However, we believe that open sourcing VCC UI and in extension, the Design System will improve the visibility and ultimately the success of the system as a whole.`}</p>
    <p>{`We're currently in talks with Legal and IP and we believe we have clear path to materialize this within the near future.`}</p>
    <h3 {...{
      "id": "upcoming-components--features"
    }}>{`Upcoming Components & Features`}</h3>
    <p>{`Looking forward, we'll increasingly be focused on delivering new features and components in VCC UI. For those of you who have access to our GitHub, you can view our `}<a parentName="p" {...{
        "href": "https://github.com/orgs/volvo-cars/projects/4"
      }}>{`backlog`}</a>{`.`}</p>
    <h2 {...{
      "id": "get-in-touch"
    }}>{`Get in touch`}</h2>
    <p>{`If you are on the Consumer Digital Slack workspace, you can find us on the #vcc-ui and #design-system channels.`}</p>
    <p>{`Otherwise, feel free to send me an email at daniel.stocks (at) volvocars.com. As always you can also find more here:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/volvo-cars/vcc-ui/"
        }}>{`VCC UI GitHub`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.npmjs.com/package/vcc-ui"
        }}>{`VCC UI NPM package`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://vcc-ui.vercel.app"
        }}>{`VCC Website`}</a></li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;